"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bonus = void 0;
const vue_1 = require("vue");
const SpaceBonus_1 = require("../SpaceBonus");
exports.Bonus = vue_1.default.component('bonus', {
    props: {
        bonus: {
            type: Array,
        },
    },
    data: function () {
        return {};
    },
    render: function (createElement) {
        const bonuses = [];
        let idx = 0;
        const build_css_class = (idx, bonus) => {
            let ret = 'board-space-bonus board-space-bonus--';
            if (bonus === SpaceBonus_1.SpaceBonus.TITANIUM) {
                ret += 'titanium';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.STEEL) {
                ret += 'steel';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.PLANT) {
                ret += 'plant';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.DRAW_CARD) {
                ret += 'card';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.HEAT) {
                ret += 'heat';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.OCEAN) {
                ret += 'bonusocean';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.ANIMAL) {
                ret += 'animal';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.MICROBE) {
                ret += 'microbe';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.TEMPERATURE) {
                ret += 'bonustemperature';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.POWER) {
                ret += 'energy';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.ASTEROID) {
                ret += 'asteroid';
            }
            ret += ' board-space-bonus-pos--' + idx.toString();
            return ret;
        };
        for (const bonus of this.bonus) {
            idx += 1;
            bonuses.push(createElement('i', { 'class': build_css_class(idx, bonus) }));
        }
        return createElement('div', { 'class': 'board-space-bonuses' }, bonuses);
    },
});
//# sourceMappingURL=Bonus.js.map